<template>
	<div> 
		<el-tabs type="card" v-model="tagConfig">
			<el-tab-pane label="Config" name="tab-cadastro">
				<span slot="label">
					<i class="fa fa-list-alt"></i> Informações Cadastrais
				</span>

				<ed-form :data="formData" :config="config" :response="response" :itens="formItems">
					<div slot="form-footer"></div>
				</ed-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import FormItems  from './_form/tabela-cadastrar'

  	export default {
  		name:"empresa",
  		components: {EdForm},
  		mixins:[Rest],
  		data () {
		   	return {
				config:{
					click:{
						save:this.salvar,
						copiar:this.getTabaleDinamica
					},
					loading:{
						save:false,
						copiar:false 
					},
					list:{
						copiar:[]
					}
				},
				response:{},
				formItems:[],
				formData:{
					id:0,
					nome:null,
					cor:null,
					ativo:1,
					obs:null,
				},
				tagConfig:'tab-cadastro'
			}
		},

		created(){
		},

		mounted: function() {
			this.formItems = FormItems;
			this.getTabaleDinamica();
		},
		methods: {

			getTabaleDinamica(search){
				
				this.config.loading.copiar = true;
				this.config.list.copiar = []
				
				var filter = {ativo:1};

				this.get('/ltcat/tabela-dinamica',{search:search,filter:filter}).then((result)=>{

					result = result[0];
						
					this.config.loading.copiar = false;

					if(result.status == 200){
						this.config.list.copiar = result.data.data;
					}
				});
			},

			salvar(){
				
				this.config.loading.save = true;
				this.response = {};
				
				this.post('/ltcat/tabela-dinamica/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.$router.push({name:'ltcat.tabela.editar',params:{id:result.data.id}});
					}
				});
			}

		}
  	}
</script>

<style>


</style>



// WEBPACK FOOTER //
// cadastrar.vue?747785a0